export const CANVAS_ID = 'sol';
export const CANVAS_WRAPPER_ID = 'sol_wrapper';
export const FPS_TARGET = 60;
export const SOL_DAYS_PER_REAL_SECONDS = 5;
